import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import './css/tabs.css'
import hotelcss from './css/hotelhotellist.module.css';

import { getAllEmailMessages } from "../dbconnector/connector";
import { useEffect } from 'react';

import { setErrorMessage, setMessage, clearMessage, setHTMLMessage } from "../tools/errorhandling";
import Button from 'react-bootstrap/Button';

import moment, { now } from "moment";
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


const Composeemailmessagelist = (props) => {
    const [messagelist, setMessagelist] = useState('');
    const navigate = useNavigate();
    const t = props.translation

    useEffect(() => {

        try {
            const messages = getAllEmailMessages(true, true);
            messages.then((result) => {
                if (result.status === 200) {
                    result.json().then(list => {
                        ////console.log("dddddddddd", list)
                        setMessagelist(list)
                        createlist(props.translation, list, navigate)
                    })

                } else {
                    setErrorMessage(result.status + ": " + result.message)
                }

            })
        } catch (error) {
            setErrorMessage(t("error_canotgetuserlist"))
        }
    }, []);


    const createlist = (t, list, navigate) => {
        let divlist = document.getElementById("list")

        if (divlist === null) {
            let divlistheader = document.getElementById("resultlistHeader")
            const upperdiv = document.getElementById("searchbox");//resultlist
            const resultdiv = document.getElementById("resultlist")
            const newuserdiv = document.getElementById("newuser")

            divlist = document.createElement("div");
            divlist.id = "list"

            const zoekbalk = document.createElement("input");
            zoekbalk.type = "text"
            zoekbalk.id = "Zoekbalk"
            zoekbalk.placeholder = "Search"

            if (sessionStorage.getItem('messageZoek') !== null) {
                zoekbalk.value = sessionStorage.getItem('messageZoek')
            }

            const sendlabel = document.createElement("label");
            sendlabel.id = "sendlabel"
            sendlabel.className = "labelcolor"
            sendlabel.innerText = t('IsSend')


            const sendbx = document.createElement("input");
            sendbx.type = "checkbox"
            sendbx.className = "checkbox"
            sendbx.disabled = false
            if (sessionStorage.getItem('messagesend') !== null && sessionStorage.getItem('messagesend').toString() === "false") {
                sendbx.checked = false
            } else {
                sendbx.checked = true
            }
            sendbx.label = "checkbox"

            if (sessionStorage.getItem('messagesShowAll') !== null && sessionStorage.getItem('messagesShowAll').toString() === "false") {
                sendbx.disabled = false
            } else {
                sendbx.disabled = true
            }

            sendbx.id = "send"

            const ShowAlllabel = document.createElement("label");
            ShowAlllabel.id = "activelabel"
            ShowAlllabel.className = "labelcolor"
            ShowAlllabel.innerText = t('ShowAll')


            const showall = document.createElement("input");
            showall.type = "checkbox"
            showall.className = "checkbox"
            showall.id = "showall"
            showall.checked = false
            if (sessionStorage.getItem('messagesShowAll') !== null && sessionStorage.getItem('messagesShowAll').toString() === "false") {
                showall.checked = false
            } else if (sessionStorage.getItem('messagesShowAll') !== null && sessionStorage.getItem('messagesShowAll').toString() === "true") {
                showall.checked = true
            } else { showall.checked = false }


            const addbutton = document.createElement("a");
            addbutton.id = "addbutton";
            addbutton.className = "btn btn-primary";
            addbutton.href = "/composeemailmessage/" + null;
            addbutton.innerText = t('CreateNewEmailMessage')

            sendbx.addEventListener("click", function (e) {
                const zoekbalk = document.getElementById("Zoekbalk")
                sessionStorage.setItem('messagesend', sendbx.checked)
                let intchecked = 0;
                if (sendbx.checked === true)
                    intchecked = 1;
                const filteredlist = list.filter(element => {
                    if ((element.subject).toLowerCase().includes(zoekbalk.value.toLowerCase()) && element.send === intchecked) {
                        return element
                    }
                })
                createlist(t, filteredlist, navigate)
            })

            showall.addEventListener("click", function (e) {
                sendbx.disabled = showall.checked;
                sessionStorage.setItem('messagesShowAll', showall.checked)
                const zoekbalk = document.getElementById("Zoekbalk")

                const filteredlist = list.filter(element => {
                    if ((element.subject).toLowerCase().includes(zoekbalk.value.toLowerCase())) {
                        return element
                    }
                })
                createlist(t, filteredlist, navigate)
            })

            zoekbalk.addEventListener("input", function (e) {
                sessionStorage.setItem('messageZoek', e.target.value)
                const filteredlist = list.filter(element => {
                    //console.log(element.subject)
                    if ((element.subject).toLowerCase().includes(e.target.value.toLowerCase())) {
                        return element
                    }
                })
                createlist(t, filteredlist, navigate)
            })
            if (upperdiv !== null) {
                upperdiv.appendChild(zoekbalk);
                upperdiv.appendChild(sendlabel);
                upperdiv.appendChild(sendbx);
                upperdiv.appendChild(ShowAlllabel);
                upperdiv.appendChild(showall);
            }
            if (newuserdiv !== null) {
                newuserdiv.appendChild(addbutton);
            }
             if (resultdiv !== null) {
            resultdiv.appendChild(divlist);
             }
        } else {
            divlist.innerHTML = "";
        }

        buildtable(list, divlist, navigate, t)

        try {
            if (sessionStorage.getItem('selectedmessage') !== null && document.getElementById("selector_" + sessionStorage.getItem('selectedmessage')) !== null) {
                document.getElementById("selector_" + sessionStorage.getItem('selectedmessage')).focus()
                document.getElementById("selector_" + sessionStorage.getItem('selectedmessage')).disabled = true;
            }
        }
        catch { }
    }



    const buildtable = (list, divlist, navigate, t) => {
        let filteredlist = list;

        if (sessionStorage.getItem('messageZoek') !== null) {
            filteredlist = list.filter(element => {
                if ((element.subject).toLowerCase().includes(sessionStorage.getItem('messageZoek').toLowerCase()) || element.message.includes(sessionStorage.getItem('messageZoek').toLowerCase())) {
                    return element
                }
            })
        }

        // if (document.getElementById("showall") !== null && document.getElementById("showall").checked !== null && document.getElementById("showall").checked === false) {
        //     //console.log("buildtable", document.getElementById("showall"))
        //     filteredlist.filter(element => !document.getElementById("send").checked ? element.send === 0 : element.send === 1).forEach((element, index) => {
        //         addlinetogrid(divlist, element, index, navigate, t)
        //     });
        // } else {
        filteredlist.forEach((element, index) => {
            addlinetogrid(divlist, element, index, navigate, t)
        });

        // }
    }

    const addlinetogrid = (divlist, element, index, navigate, t) => {
        //console.log("element", element)
        const employediv = document.createElement("div")
        divlist.appendChild(employediv)

        const selector = document.createElement("input");
        selector.className = "smallselector";
        selector.id = "selector_" + element.id


        const Id = document.createElement("p")
        Id.innerText = element.id
        employediv.appendChild(Id)

        const EMP_ID_div = document.createElement("p")
        EMP_ID_div.innerText = element.subject
        employediv.appendChild(EMP_ID_div)


        const phone = document.createElement("p")
        phone.innerText = moment(new Date(element.date)).format("DD-MMM-YYYY hh:mm")
        employediv.appendChild(phone)

        const active = document.createElement("p")
        if (element.send === 0) {
            active.innerText = "false"
        } else {
            active.innerText = "true"
        }
        employediv.appendChild(active)

        const senddate = document.createElement("p")
        if (element.senddate !== null)
            senddate.innerText = moment(new Date(element.senddate)).format("DD-MMM-YYYY hh:mm")//.toLocaleString("en-US")
        employediv.appendChild(senddate)

        if (sessionStorage.getItem('selectedmessage') === element.id.toString()) {
            employediv.className += hotelcss.linkVarientMessageSelectedRow
            employediv.appendChild(selector);
        } else {
            if (index % 2 === 0) {
                employediv.className = hotelcss.linkVarient2Message //"linkVarient1 gridEmployees"
            } else {
                employediv.className = hotelcss.linkVarient1Message
            }
        }
        employediv.addEventListener('click', function (e) {
            sessionStorage.setItem('selectedmessage', element.id)
            navigate("/composeemailmessage/" + element.id);
        });
    }

    return (
        <div id="main">
            <header>
                <div id="errordiv" className='error'>
                </div>
                {/* <div className="checkinTime">
                    <div id="timelabel" >
                    </div>
                    <div id="time">
                    </div>
                </div> */}
            </header>
            <div id="newuser" className="form">
            </div>
            <div id="filters" className="form" >
                <label className='formtitleContentBox'>{t('filterinstellingen')}</label>
                <br></br>
                <div className="contentbox ">
                    <div id="searchbox" className="formElement">
                        <label className='labelcolor'>
                            {t('Subject')}:
                        </label>
                    </div>
                </div>
                <div id="headertable" className={hotelcss.messagetableheader}><p id="ID">{t('ID')}</p><p id="Subject">{t('Subject')}</p><p id="Date">{t('Date')}</p><p id="Send">{t('IsSend')}</p><p id="Senddate">{t('Senddate')}</p></div>
                <div id="resultlist" className='list'>
                </div>
            </div>
        </div>
    )
}

export default Composeemailmessagelist